import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ALT_THUMBNAIL, API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import {  getAllContactUsApi } from "./Api";
import { ComponentHeader } from "../common";
import { withRouter } from "../../utils/hoc/withRouter";
import moment from "moment";


export class ContactUs extends Component {
  constructor(props) {

    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.ContactUs);
    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: ''
    };
  }
  // todo---------------------------------------
  componentDidMount() {

    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllContactUsApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";
    const prevSearch = prevParams.get("search") || "";
    const pageSize = params.get("pageSize") || API_LIMIT;
    const prevPageSize = prevParams.get("pageSize") || API_LIMIT;

    const verified = params.get("isVerified") || "";
    if (prevPage !== page || prevVerified !== verified  || prevSearch !== search || prevPageSize !== pageSize) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllContactUsApi(this);

      });
    }
  }

  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">

    
        <ComponentHeader
          title="Contact Us List"
          isSearch={true}
          placeholder={"Search "}
          onChangeMethod={this.onChangeMethod}
        />
        <div className="commom-table-wrapper">

          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[
              {
                width: 250,
                title: "Name",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.name;
                },
              },
              {
                width: 250,
                title: "Email",
                dataIndex: "email",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.email;
                },
              },
              {
                width: 150,
                title: "Mobile Number",
                dataIndex: "mobileNumber",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.mobileNumber;
                },
              },
              {
                width: 150,
                title: "Reason For Contact",
                dataIndex: "reasonForContact",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.reasonForContact;
                },
              },
              {
                width: 250,
                title: "Message",
                dataIndex: "message",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.message;
                },
              },
               {
                width: 250,
                title: "Date of Contact",
                dataIndex: "dateOfContact",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    const date = moment(rowData?.createdAt).format("lll");
                    return date;
                }
              },

              
            ]}
           
            total={listData?.length || 0}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllContactUsApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContactUs));